const config = {
  baseUrl: 'https://newapi.xingtanyixun.cn/'
  //baseUrl: 'https://testots.xingtanyipai.com/webapi/'
}
module.exports = {
  config: config
}